import { NavLink } from "react-router-dom";

const Header = ({links, onLogout}) => (
    <div className="App">
        <div className="bg-gray-900 text-white font-sans flex">
            <div className="max-w-2xl mx-auto py-8">
                <nav>
                    <ul className="flex space-x-6 border-b border-gray-700 pb-3 text-sm uppercase">
                        {links.map(({path, label, end}) => (
                            <li key={path}>
                                <NavLink
                                    to={path}
                                    end={end}
                                    className={({ isActive }) => isActive ? "text-green-500" : "text-gray-400 hover:text-green-500"}
                                >
                                    {label}
                                </NavLink>
                            </li>
                        ))}
                        <button onClick={onLogout} className="text-gray-400 hover:text-red-500 ml-4">LOGOUT</button>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
)

export default Header;